import type { SceneContext } from '../_shared/types'
import type { QuoteData, QuoteBg } from './types'
import { quoteRevealed } from './tick'

const BG: Record<QuoteBg, string> = {
  dark: 'linear-gradient(160deg,#0f172a,#1e293b)',
  warm: 'linear-gradient(160deg,#2e1a0f,#3d2010)',
  cool: 'linear-gradient(160deg,#0f172a,#1e3a5f)',
  minimal: 'linear-gradient(160deg,#f8fafc,#e2e8f0)',
}

export default function QuoteCard({ data, time, duration }: SceneContext) {
  const d = data as unknown as QuoteData
  const revealed = quoteRevealed(data, time, duration)
  const textColor = d.background === 'minimal' ? '#1e293b' : '#fff'
  const done = revealed >= (d.quote?.length ?? 0)
  const visible = done ? d.quote : (d.quote || '').substring(0, revealed)
  return (
    <div className="pv-quote" style={{ background: (data as any).bgColor || BG[d.background] || BG.dark }}>
      <div className="pv-quote-mark" style={{ color: 'var(--p)' }}>
        &ldquo;
      </div>
      <div className="pv-quote-text" style={{ color: textColor }}>
        {visible}
        <span className="pv-cursor" style={{ opacity: done ? 0 : 1 }}>
          |
        </span>
      </div>
      <div className="pv-quote-author" style={{ color: textColor, opacity: 0.6 }}>
        — {d.author}
      </div>
    </div>
  )
}
